export const radiiNamingPx = ['xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'] as const;
export const radiiNamingPrcnt = ['half', 'quarter'] as const;

type BorderRadiiInPixelsType = typeof radiiNamingPx[number];
type BorderRadiiInPercentageType = typeof radiiNamingPrcnt[number];

export type BorderRadiiInterface = {
    pixel: Record<BorderRadiiInPixelsType, number>,
    percentage: Record<BorderRadiiInPercentageType, number>,
}

const borderRadii: BorderRadiiInterface = {
    pixel: {
        'xs': 4,
        's': 8,
        'm': 16,
        'l': 24,
        'xl': 32,
        'xxl': 64,
        'xxxl': 128,
    },
    percentage: {
        'half': 50,
        'quarter': 25,
    },
};

export default borderRadii;
